// extracted by mini-css-extract-plugin
module.exports = {"button":"Capture_button_1wVdO","capture":"Capture_capture_GbaK-"};